import { useTheme } from '../../../hooks/theme';
import { Text, Link, Subtitle } from 'mondrian-react';
import Menu from '../../../components/Menu';
import Footer from '../../../components/Footer';
import styles from './styles.module.css';

function AuthLayout({ children }) {
  // const { colorTheme, themeSwitcher } = useTheme();

  // themeSwitcher();

  const colorTheme = 'claro'; // fixed theme.

  return (
    <>
      <Menu />

      <div className={`mdn-Container-fluid ${styles['mdn-Container-fluid']}`}>
        <div className={styles.Background}>
          <div className={`mdn-Container ${styles.Container}`}>
            <div className={styles.CardText}>
              <Subtitle className={styles.Title}>Catálogo de Dados</Subtitle>
              <Text body className={styles.Textbody}>
                O Catálogo de Dados é o consolidador de metadados da Claro. Com
                ele é possível encontrar termos técnicos, termos de negócio e
                informações sobre APIs de forma rápida e eficiente.
              </Text>
            </div>

            <div className={styles.CardContainer}>
              <div
                className={
                  colorTheme === 'claro' ? styles.Card : styles.CardContrast
                }
              >
                <Text
                  body
                  className={
                    colorTheme === 'claro'
                      ? styles.CardHeader
                      : styles.CardHeaderContrast
                  }
                  id="CardHeader"
                >
                  Utilize seu usuário e senha para entrar no Catálogo de dados.
                </Text>

                {children}
              </div>
              <Text body className={styles.TextBottom}>
                Essa plataforma possui usuário e senhas apartados da rede claro,
                por isso, se você ainda não se cadastrou, cadastre-se.
              </Text>
            </div>
          </div>
          <div className={`mdn-Container ${styles.BackgroundFooter}`}>
            <img
              src="https://mondrian.claro.com.br/brands/horizontal/inverse/beon.svg"
              alt=""
            />

            <Link
              inverse
              href="https://forms.office.com/Pages/ResponsePage.aspx?id=S30kVTW0pUeIG8p2J0NOeYsid-bq8fFCmxjF-wCXjBFUMEdaRE9JSUNZVFJMTVhGWUZQSUZWQjNMRy4u"
              className={styles.BackgroundFooterFeedback}
              target="_blank"
            >
              Feedback
            </Link>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default AuthLayout;
